import React, { useState } from 'react';
import UserMenu from './UserMenu';
import { Tooltip } from 'antd';
import { IconTrashX } from '@tabler/icons-react';
// import ModalHistoriBarangTerhapus from './ModalHistoriBarangTerhapus';

function Header({ sidebarOpen, setSidebarOpen, title, openModal, compFilter, dateFilter }) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  function closeModal() {
    setIsOpenModal(false);
  }
  return (
    <header className="sticky top-0 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700/80 z-40 transition-colors">
      {/* <ModalHistoriBarangTerhapus isOpen={isOpenModal} closeModal={closeModal} /> */}
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 -mb-px">
          {/* Header: Left side & Hamburger */}
          <div className="flex justify-between items-center w-full">
            <div className="flex items-center gap-3">
              {/* Hamburger button - Show/hide sidebar toggle */}
              <button
                className="flex items-center justify-center shrink-0 p-1.5 -ml-1 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 hover:bg-amber-100/60 dark:hover:bg-slate-700/60 rounded-lg transition-colors cursor-pointer focus:outline-none"
                aria-controls="sidebar"
                aria-expanded={sidebarOpen}
                title={sidebarOpen ? "Sembunyikan Menu Sidebar" : "Tampilkan Menu Sidebar"}
                onClick={(e) => {
                  e.stopPropagation();
                  setSidebarOpen(!sidebarOpen);
                }}
              >
                <span className="sr-only">Toggle sidebar</span>
                <svg className="block w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <rect x="4" y="5" width="16" height="2" rx="1" />
                  <rect x="4" y="11" width="16" height="2" rx="1" />
                  <rect x="4" y="17" width="16" height="2" rx="1" />
                </svg>
              </button>

              {title && (
                <h1 className="whitespace-nowrap text-sm sm:text-base font-bold text-slate-900 dark:text-slate-100 leading-none pt-[7px]">
                  {title}
                </h1>
              )}

              {dateFilter && dateFilter !== 'Invalid date' && (
                <p className="font-semibold text-sm text-slate-700 dark:text-slate-300 md:block hidden ml-2">
                  {dateFilter}
                </p>
              )}
            </div>
            <div>{compFilter}</div>
          </div>

          {/* Header: Right side */}
          <div className="flex items-center">
            <hr className="w-px h-6 bg-slate-200 dark:bg-slate-700 mx-3 hidden md:block" />
            {/* <Tooltip title="Histori Barang">
              <button onClick={() => setIsOpenModal(true)} className="bg-slate-300 rounded-md p-1.5">
                <IconTrashX />
              </button>
            </Tooltip> */}
            <UserMenu />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
